<ng-template #modalDiv style="top:20%;" let-modal>
  <div class="modal-header">{{header}}
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    {{message}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss()">Dismiss</button>
  </div>
</ng-template>
